import axiosTokenInstance from 'services/api/backoffice';
import { LIST_FREE_TRIAL_IPB, LIST_FREE_TRIAL_IPB_ERROR } from '_models/redux/types';

export const listFreeTrialIpbAction =
  (page = 1, size = 10, filters = {}) =>
  async (dispatch) => {
    try {
      const params = { page, size, ...filters };
      const response = await axiosTokenInstance.get(`/api/backoffice/orders/free-trials?`, {
        params,
      });

      const { data, status } = response || {};

      dispatch({
        type: LIST_FREE_TRIAL_IPB,
        payload: data || {},
        status: status || {},
        method: 'get',
      });
    } catch (e) {
      dispatch({
        type: LIST_FREE_TRIAL_IPB_ERROR,
        payload: e || {},
      });
    }
  };
